import React, { Component } from "react";
export default class SocialCongPartA extends Component {
  render() {
    var {
      social_congnition_statuspa1,
      social_congnition_statuspa2,
      social_congnition_statuspa3,
      social_congnition_statuspa4,
      social_congnition_statuspa5,
      social_congnition_statuspa6,
    } = this.props.data;
    return (
      <div className="row border border-dark bg-white">
        <div className="col-lg-12">
          <br />
          <div className="row">
            <div className="col-12 col-sm-6 col-lg-6 col-md-6 d-flex align-items-baseline">
              <p className="social-cog-para-for-num" style={{ top: -51 }}>
                1){" "}
              </p>
              <div className="social-rec-form-1" style={{ marginLeft: 13 }}>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_statuspa1 == "1"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={"./assets/images/social-cognition-part-a/1/1.png"}
                        alt="social r 1"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_statuspa1 == "2"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={"./assets/images/social-cognition-part-a/1/2.png"}
                        alt="social r 2"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_statuspa1 == "3"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={"./assets/images/social-cognition-part-a/1/3.png"}
                        alt="social r 3"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_statuspa1 == "4"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={"./assets/images/social-cognition-part-a/1/4.png"}
                        alt="social r 4"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-lg-6 col-md-6 d-flex align-items-baseline">
              <p className="social-cog-para-for-num" style={{ top: -51 }}>
                2){" "}
              </p>
              <div className="social-rec-form-1" style={{ marginLeft: 13 }}>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_statuspa2 == "1"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={"./assets/images/social-cognition-part-a/2/1.png"}
                        alt="s c 21"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_statuspa2 == "2"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={"./assets/images/social-cognition-part-a/2/2.png"}
                        alt="s c 22"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_statuspa2 == "3"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={"./assets/images/social-cognition-part-a/2/3.png"}
                        alt="s c 23"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_statuspa2 == "4"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={"./assets/images/social-cognition-part-a/2/4.png"}
                        alt="s c 24"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-lg-6 col-md-6 d-flex align-items-baseline">
              <p className="social-cog-para-for-num" style={{ top: -51 }}>
                3){" "}
              </p>
              <div className="social-rec-form-1" style={{ marginLeft: 13 }}>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_statuspa3 == "1"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={"./assets/images/social-cognition-part-a/3/1.png"}
                        alt="s c 21"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_statuspa3 == "2"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={"./assets/images/social-cognition-part-a/3/2.png"}
                        alt="s c 22"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_statuspa3 == "3"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={"./assets/images/social-cognition-part-a/3/3.png"}
                        alt="s c 23"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_statuspa3 == "4"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={"./assets/images/social-cognition-part-a/3/4.png"}
                        alt="s c 24"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-lg-6 col-md-6 d-flex align-items-baseline">
              <p className="social-cog-para-for-num" style={{ top: -51 }}>
                4){" "}
              </p>
              <div className="social-rec-form-1" style={{ marginLeft: 13 }}>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_statuspa4 == "1"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={"./assets/images/social-cognition-part-a/4/1.png"}
                        alt="s c 21"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_statuspa4 == "2"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={"./assets/images/social-cognition-part-a/4/2.png"}
                        alt="s c 22"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_statuspa4 == "3"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={"./assets/images/social-cognition-part-a/4/3.png"}
                        alt="s c 23"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_statuspa4 == "4"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={"./assets/images/social-cognition-part-a/4/4.png"}
                        alt="s c 24"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-lg-6 col-md-6 d-flex align-items-baseline">
              <p className="social-cog-para-for-num" style={{ top: -51 }}>
                5){" "}
              </p>
              <div className="social-rec-form-1" style={{ marginLeft: 13 }}>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_statuspa5 == "1"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={"./assets/images/social-cognition-part-a/5/1.png"}
                        alt="s c 21"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_statuspa5 == "2"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={"./assets/images/social-cognition-part-a/5/2.png"}
                        alt="s c 22"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_statuspa5 == "3"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={"./assets/images/social-cognition-part-a/5/3.png"}
                        alt="s c 23"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_statuspa5 == "4"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={"./assets/images/social-cognition-part-a/5/4.png"}
                        alt="s c 24"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-lg-6 col-md-6 d-flex align-items-baseline">
              <p className="social-cog-para-for-num" style={{ top: -51 }}>
                6){" "}
              </p>
              <div className="social-rec-form-1" style={{ marginLeft: 13 }}>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_statuspa6 == "1"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={"./assets/images/social-cognition-part-a/6/1.png"}
                        alt="s c 21"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_statuspa6 == "2"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={"./assets/images/social-cognition-part-a/6/2.png"}
                        alt="s c 22"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_statuspa6 == "3"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={"./assets/images/social-cognition-part-a/6/3.png"}
                        alt="s c 23"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_statuspa6 == "4"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={"./assets/images/social-cognition-part-a/6/4.png"}
                        alt="s c 24"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
        </div>
        <div
          className="col-lg-2 pt-4"
          style={{ borderLeft: "1px solid #000" }}
        ></div>
      </div>
    );
  }
}
